export function add_units_event_listeners() {
  const fixedFloorSelection = document.querySelector('#fixed_floor_selection');
  const btnFixedFloorNo = document.querySelector('#button_fixed_floor_no');
  const btnFixedFloorYes = document.querySelector('#button_fixed_floor_yes');
  const withoutFixedFloor = document.querySelector('#without_fixed_floor');
  const withFixedFloor = document.querySelector('#with_fixed_floor');
  const formCheck = document.querySelectorAll('.form-check-label');
  const fixedFloorFalse = formCheck[2];
  const fixedFloorTrue = formCheck[3];

  const floorTenantListInputTrue = document.querySelector(
    '#button_tenant_list_floor_number_yes'
  );
  const floorTenantListInputFalse = document.querySelector(
    '#button_tenant_list_floor_number_no'
  );

  const fixedFloorInputTrue = document.querySelector('#button_fixed_floor_yes');
  const fixedFloorInputFalse = document.querySelector('#button_fixed_floor_no');

  const floorNumberExtractorInput = document.querySelector(
    '#unit_floor_number_extractor'
  );
  const fixedFloorNumberInput = document.querySelector('#unit_fixed_floor_number');

  const createBtn = document.querySelector('#submit_unit');

  const unitConfiguration = [
    fixedFloorSelection,
    btnFixedFloorNo,
    btnFixedFloorYes,
    fixedFloorFalse,
    fixedFloorTrue,
  ];

  const updateFloorFieldRequirements = () => {
    if (!floorNumberExtractorInput || !fixedFloorNumberInput) return;

    const useSchemaFloorNumber =
      document.querySelector('input[name="unit[use_schema_floor_number]"]:checked')
        ?.value === 'true';
    const hasFixedFloor =
      document.querySelector('input[name="unit[fixed_floor]"]:checked')?.value ===
      'true';

    if (useSchemaFloorNumber) {
      floorNumberExtractorInput.required = false;
      floorNumberExtractorInput.disabled = true;
      floorNumberExtractorInput.value = '';

      fixedFloorNumberInput.required = false;
      fixedFloorNumberInput.disabled = true;
      fixedFloorNumberInput.value = '';
      return;
    }

    if (hasFixedFloor) {
      floorNumberExtractorInput.required = false;
      floorNumberExtractorInput.disabled = true;
      floorNumberExtractorInput.value = '';

      fixedFloorNumberInput.disabled = false;
      fixedFloorNumberInput.required = true;
      return;
    }

    floorNumberExtractorInput.disabled = false;
    floorNumberExtractorInput.required = true;

    fixedFloorNumberInput.required = false;
    fixedFloorNumberInput.disabled = true;
    fixedFloorNumberInput.value = '';
  };

  if (floorTenantListInputFalse) {
    floorTenantListInputFalse.addEventListener('click', () => {
      unitConfiguration.forEach(configItem => {
        configItem.classList.remove('unit-hide-fixed-floor');
      });
      withoutFixedFloor.classList.remove('unit-hide-fixed-floor');
      updateFloorFieldRequirements();
    });
  }

  if (floorTenantListInputTrue) {
    floorTenantListInputTrue.addEventListener('click', () => {
      unitConfiguration.forEach(configItem => {
        configItem.classList.add('unit-hide-fixed-floor');
      });
      withoutFixedFloor.classList.add('unit-hide-fixed-floor');
      updateFloorFieldRequirements();
    });
  }

  if (fixedFloorInputFalse) {
    fixedFloorInputFalse.addEventListener('click', () => {
      withoutFixedFloor.classList.remove('unit-hide-fixed-floor');
      withFixedFloor.classList.add('unit-hide-fixed-floor');
      updateFloorFieldRequirements();
    });
  }

  if (fixedFloorInputTrue) {
    fixedFloorInputTrue.addEventListener('click', () => {
      withoutFixedFloor.classList.add('unit-hide-fixed-floor');
      withFixedFloor.classList.remove('unit-hide-fixed-floor');
      updateFloorFieldRequirements();
    });
  }

  if (createBtn) {
    createBtn.addEventListener('click', () => updateFloorFieldRequirements());
  }

  updateFloorFieldRequirements();
}
